import { createFileRoute } from '@tanstack/react-router';

import { BlockCreateKindPage, blockKindParamSchema } from '@/features/content';

/** `banner` or `rail`; anything else fails to parse and renders the route error. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blocks/new/$kind')({
  params: {
    parse: (raw) => ({ kind: blockKindParamSchema.parse(raw.kind) }),
    stringify: (params) => ({ kind: params.kind }),
  },
  component: BlockCreateKindPage,
});
